import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import WarmerSKUCategory from './WarmerSKUCategory';
import { withRouter } from 'react-router-dom';
import { getAvailablePages, getPageLabel } from '../../services/pageNavigation';

const base = 'insta-service';

@inject('ProductionStore', 'UserStore')
@observer
class CurrentWarmerStock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pages: []
        };
    }
    componentDidMount() {
        const {
            UserStore: { position },
        } = this.props;
        const pages = getAvailablePages(position);

        this.setState({pages: pages})
    }

    handleSetPage = (page) => {
        const {
            history,
            UserStore: { setPage },
        } = this.props;

        setPage(page);
        history.push(`/${page}`);
    };

    render() {
        const {
            pages
        } = this.state;
        const {
            UserStore: {
                currentPage,
                handleSetFullscreen,
                isCurrentPageFullScreen,
            },
            currentWarmerStocks
        } = this.props;

        const groupedByLocation = currentWarmerStocks.reduce((acc, entry) => {
            const location = entry.insta_service_location || 'Warmer';
            if (!acc[location]) acc[location] = [];
            acc[location].push(entry);
            return acc;
        }, {});

        const locations = ['Warmer', 'Sous Vide', 'Chiller'];
        const groupedData = locations.map(location => {
            const entries = groupedByLocation[location] || [];
            const groupedByCategory = entries.reduce((acc, entry) => {
                const { category } = entry;
                if (!acc[category]) acc[category] = [];
                acc[category].push(entry);
                return acc;
            }, {});

            const categories = Object.keys(groupedByCategory).map(category => ({
                category,
                items: groupedByCategory[category].sort((a, b) => b.quantity - a.quantity)
            })).sort((a, b) => b.items.length - a.items.length);

            return { location, categories };
        });

        return (
            <div className={`${base}__grid_wrapper`}>
                {['Warmer', 'Sous Vide', 'Chiller'].map((loc) => (
                    <div key={loc} className={`${base}__nav_section`}>
                        IN {loc.toUpperCase()}
                    </div>
                ))}

                <div className={`${base}__nav_actions`}>
                    <button
                        className={`${base}__fullscreen_btn`}
                        onClick={() => handleSetFullscreen(!isCurrentPageFullScreen)}
                    >
                        <img
                            className={`${base}__exit_fullscreen_icon`}
                            src={
                                isCurrentPageFullScreen
                                    ? "https://image.popcontent.link/exit-full-screen.png"
                                    : "https://image.popcontent.link/go_full_screen.png"
                            }
                            alt="Exit fullscreen"
                        />
                    </button>

                    {isCurrentPageFullScreen && (
                        <div className={`${base}__dropdown`}>
                            {getPageLabel(currentPage)}
                            <svg fill="#fff" className="iconmoon-icon">
                                <use xlinkHref="#icon-caret-down" />
                            </svg>
                            <div className="dropdown-content pages">
                                {pages
                                    .filter((page) => page !== currentPage)
                                    .map((page, i) => (
                                        <a key={i} onClick={() => this.handleSetPage(page)}>
                                            {getPageLabel(page)}
                                        </a>
                                    ))}
                            </div>
                        </div>
                    )}
                </div>

                {groupedData.map(({ location, categories }) => (
                    <div key={location} className={`${base}__location_column`}>
                        {categories.length > 0 ? (
                            categories.map((category) => (
                                <WarmerSKUCategory
                                    key={`${location}-${category.category}`}
                                    category={category}
                                    isCurrentStock={false}
                                />
                            ))
                        ) : (
                            <p className={`${base}__no_items`}>No items in {location}</p>
                        )}
                    </div>
                ))}

                <div className={`${base}__location_column ${base}__actions_column_placeholder`}>
                </div>
            </div>
        );
    }
}

export default withRouter(CurrentWarmerStock);
